import React, { useEffect, useState } from "react";
import axios from "axios"; 
import { useParams, useNavigate, Link } from "react-router-dom";
import config from '../../config';

function PackegeDetails() {
    const { id } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [topVenueTitles, setTopVenueTitles] = useState([]);
    const navigate = useNavigate();

    const fetchEventDetails = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-packege/${id}`, { withCredentials: true });
            const ev = response.data;
            setEvent(ev);
            // Fetch top venue titles if available
            if (Array.isArray(ev.topVenues) && ev.topVenues.length) {
                try {
                    const titles = await Promise.all(
                        ev.topVenues.map(async (vid) => {
                            const venueId = typeof vid === 'string' ? vid : vid?._id;
                            if (!venueId) return null;
                            const res = await axios.get(`${config.BASE_URL}/api/admin/get-venue/${venueId}`, { withCredentials: true });
                            return res.data?.title || null;
                        })
                    );
                    setTopVenueTitles(titles.filter(Boolean));
                } catch (_) {}
            }
        } catch (err) {
            setError('Failed to fetch packege details');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEventDetails();
    }, [id]);

    const handleDelete = async () => {
        try {
            await axios.delete(`${config.BASE_URL}/api/admin/delete-packege/${id}`, { withCredentials: true });
            navigate('/admin/packages'); 
        } catch (err) {
            setError('Failed to delete the event');
        }
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="dashboard project_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Dashboard</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>
                <div className="main-section">
                    <div className="projects">
                        <div className="projects-inner">
                            <div className="detail_item">
                                <h2>Packege Title</h2>
                                <div className="detail_item_inner">
                                    <p>{event.title}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Description</h2>
                                <div className="detail_item_inner">
                                    <p>{event?.description || '-'}</p>
                                </div>
                            </div>

                            <div className="detail_item twoImages">
                                <div className="detail_item">
                                    <div className="detail_banner_wrap">
                                        <div className="detail_img_grid">
                                            {event.featuredImage ? (
                                                <div className="detail_img_item">
                                                    <h2>Featured Image</h2>
                                                    <div className="banner_img_wrap">
                                                        <img src={`${config.BASE_URL}${event.featuredImage}`} alt="Featured" />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>
                                                    <h2>Featured Image</h2>
                                                    <p>No image available.</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="detail_item">
                                <h2>Gallery Images</h2>
                                <div className="detail_item_inner">
                                    <div className="detail_img_grid">
                                        {event.galleryImages && event.galleryImages.length > 0 ? (
                                            event.galleryImages.map((image, index) => (
                                                <div className="detail_img_item" key={index}>
                                                    <img src={`${config.BASE_URL}${image}`} alt={`event image ${index}`} />
                                                </div>
                                            ))
                                        ) : (
                                            <p>No Gallery images available.</p>
                                        )}
                                    </div>
                                </div>
                            </div> */}

                            <div className="detail_item">
                                <h1>Center Content</h1>
                                <div className="detail_banner_wrap">
                                    <div className="detail_img_grid">
                                        {event.centerContentImage ? (
                                            <div className="detail_img_item">
                                                <h2>Image</h2>
                                                <div className="banner_img_wrap">
                                                    <img src={`${config.BASE_URL}${event.centerContentImage}`} alt="Center" />
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <h2>Image</h2>
                                                <p>No image available.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* <div className="detail_item">
                                <h2>Top Text</h2>
                                <div className="detail_item_inner">
                                    <p>{event?.centerContent?.topText}</p>
                                </div>
                            </div> */}

                            <div className="detail_item">
                                <h2>Left Text</h2>
                                <div className="detail_item_inner">
                                    <p>{event?.centerContent?.leftText}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Right Text</h2>
                                <div className="detail_item_inner">
                                    <p>{event?.centerContent?.rightText}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Best For</h2>
                                <div className="detail_item_inner">
                                    <p>{Array.isArray(event.attributeBestFor) && event.attributeBestFor.length ? event.attributeBestFor.join(', ') : '-'}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Best Season</h2>
                                <div className="detail_item_inner">
                                    <p>{Array.isArray(event.attributeBestSeason) && event.attributeBestSeason.length ? event.attributeBestSeason.join(', ') : '-'}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Top Venues</h2>
                                <div className="detail_item_inner">
                                    <p>{topVenueTitles.length ? topVenueTitles.join(', ') : '-'}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Booking</h2>
                                <div className="detail_item_inner">
                                    <p><strong>Description:</strong> {event?.bookingInfo?.description || '-'}</p>
                                    <p><strong>Link:</strong> {event?.bookingInfo?.link ? <a href={event.bookingInfo.link} target="_blank" rel="noreferrer">{event.bookingInfo.link}</a> : '-'}</p>
                                    {event?.bookingInfo?.image && (
                                        <div className="detail_img_item" style={{marginTop: 12}}>
                                            <img src={`${config.BASE_URL}${event.bookingInfo.image}`} alt="booking" />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Featured</h2>
                                <div className="detail_item_inner">
                                    <p>{event?.isFeatured ? 'Yes' : 'No'}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h1>Plans</h1>
                                {Array.isArray(event.plans) && event.plans.length ? event.plans.map((plan, idx) => (
                                    <div key={idx} className="singleItinerary">
                                        <div className="detail_item">
                                            <h2>Title</h2>
                                            <div className="detail_item_inner">
                                                <p>{plan.title}</p>
                                            </div>
                                        </div>
                                        {plan.description && (
                                            <div className="detail_item">
                                                <h2>Description</h2>
                                                <div className="detail_item_inner">
                                                    <p>{plan.description}</p>
                                                </div>
                                            </div>
                                        )}
                                        {Array.isArray(plan.others) && plan.others.length > 0 && (
                                            <div className="detail_item">
                                                <h2>Others</h2>
                                                <div className="detail_item_inner">
                                                    {plan.others.map((o, oi) => (
                                                        <div key={oi} style={{marginBottom:8}}>
                                                            {o.image && <img src={`${config.BASE_URL}${o.image}`} alt="plan-other" style={{maxWidth:200}} />}
                                                            {o.text && <p>{o.text}</p>}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )) : <p>-</p>}
                            </div>

                            <div className="detail_item">
                                <h1>Additional Details</h1>
                                {Array.isArray(event.additionalDetails) && event.additionalDetails.length ? event.additionalDetails.map((sec, si) => (
                                    <div key={si} className="singleItinerary">
                                        <div className="detail_item">
                                            <h2>Section</h2>
                                            <div className="detail_item_inner">
                                                <p>{sec.text}</p>
                                            </div>
                                        </div>
                                        {Array.isArray(sec.details) && sec.details.length > 0 && (
                                            <div className="detail_item_inner" style={{display:'flex',gap:12,flexWrap:'wrap'}}>
                                                {sec.details.map((d, di) => (
                                                    <div key={di}>
                                                        {d.image && <img src={`${config.BASE_URL}${d.image}`} alt="additional" style={{maxWidth:200}} />}
                                                        {d.description && <p>{d.description}</p>}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )) : <p>-</p>}
                            </div>

                            <div className="detail_project_btn_wrap">
                                <div className="detail_edit_del">
                                    <div className="btn_item">
                                        <button className="detail_btns" onClick={handleDelete}>Delete</button>
                                    </div>
                                    <div className="btn_item">
                                        <Link to={`/admin/update-package/${event._id}`} className="update_detail detail_btns">Edit</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PackegeDetails;
